export default [
  "HAHA You Suck",
  "My dog better than you",
  "Did you even try?",
  "Just give up"
];
